import {
	ACCEPT_INFORMATION_COLLABORATOR,
	ACCEPT_INFORMATION_COLLABORATOR_ERROR,
	ACCEPT_INFORMATION_COLLABORATOR_SUCCESS,
	ACCEPT_INFORMATION_COLLABORATOR_ERROR_SHOW,
} from '../../constants';

export const acceptInfoCollaboratorReducer = (state, actions) => {
	switch (actions.type) {
		case ACCEPT_INFORMATION_COLLABORATOR:
			return {
				...state,
				loading: true,
			};
		case ACCEPT_INFORMATION_COLLABORATOR_ERROR:
			return {
				collaborators: state.collaborators,
				//	collaboratorsOptions: state.collaboratorsOptions,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case ACCEPT_INFORMATION_COLLABORATOR_SUCCESS:
			return {
				collaborators: actions.payload,
				//collaboratorsOptions: getCollaboratorOptions(actions.payload),
				loading: false,
				error: null,
				errorShow: false,
			};
		case ACCEPT_INFORMATION_COLLABORATOR_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
